export const inr = n => (n === null || n === undefined ? '—' : `₹${Math.round(n).toLocaleString('en-IN')}`);
export const pct = n => (n === null || n === undefined ? '—' : `${n}%`);
export const when = v => (v ? new Date(v).toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');
export const monthLabel = m => new Date(`${m}-01`).toLocaleDateString('en-IN', { month: 'short', year: '2-digit' });
